var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInactiveIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "46px",
    height: "50px",
    viewBox: "0 0 46 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "11.6606432%",
    y1: "0%",
    x2: "88.3393568%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A1CB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004D67",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Session-Timed-Out-Modal-Copy",
    transform: "translate(-555.000000, -90.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(525.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(30.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.8501902,15.4087598 C43.2148339,18.9848704 46,24.41718 46,30.5 C46,41.2695526 37.2695526,50 26.5,50 C23.6822045,50 21.0040018,49.4023318 18.585245,48.3268484 C24.8452255,48.3172455 35.7239695,46.2534351 40,32 C41.98,25.4 41.1286,19.9979 38.991091,15.685889 Z M25,25 C22.1419702,34.288597 15.1997731,37.9614639 8.91543167,38.9367689 C7.68755535,36.3839526 7,33.5222699 7,30.5 C7,20.1701382 15.0321201,11.7162786 25.1915796,11.043202 C26.638323,15.2309902 26.5744292,19.883105 25,25 Z",
    id: "Combined-Shape",
    fill: "#007EA8",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icons/Time-Map-Location/alarm",
    transform: "translate(0.008044, 0.999000)",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7059559,47.999 L18.7049559,47.999 C11.5639559,47.999 4.64695594,44.488 0.201955943,38.606 C-0.0510440566,38.272 -0.0670440566,37.816 0.157955943,37.463 C0.383955943,37.113 0.806955943,36.938 1.21595594,37.028 C3.89495594,37.615 6.46095594,37.692 8.84295594,37.252 C19.6329559,35.265 26.8399559,24.606 24.9089559,13.489 C24.1349559,9.043 21.8029559,4.871 18.3429559,1.74 C18.0329559,1.461 17.9309559,1.017 18.0839559,0.631 C18.2399559,0.242 18.6119559,0.008 19.0349559,0 C30.1939559,0.23 39.7109559,8.547 41.6639559,19.775 C43.9309559,32.8 35.4599559,45.294 22.7809559,47.626 C21.4359559,47.875 20.0639559,47.999 18.7059559,47.999 Z M3.52895594,39.424 C7.54595594,43.579 13.0509559,45.999 18.7049559,45.999 L18.7059559,45.999 C19.9429559,45.999 21.1919559,45.884 22.4189559,45.659 C34.0229559,43.524 41.7709559,32.066 39.6919559,20.117 C38.0569559,10.723 30.6559559,3.553 21.6119559,2.219 C24.3409559,5.346 26.1839559,9.143 26.8809559,13.148 C28.9989559,25.339 21.0689559,37.035 9.20495594,39.219 C7.39095594,39.551 5.49495594,39.623 3.52895594,39.424 Z",
    id: "Shape"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveIcon);
export default __webpack_public_path__ + "static/media/inactive-icon.50d1a99f9b757f1c591701e8bf0f40dd.svg";
export { ForwardRef as ReactComponent };